<template>
  <div>
    <div class="text-h5 text-center q-mb-xl">
      <platform-icon :platform="platform" />
      Login to {{ platform }}
    </div>
    <form v-if="!captcha && !mfa" class="q-gutter-y-md" @submit.prevent="login">
      <q-input label="Email Address or Phone Number" v-model="credentials.id" outlined />
      <password-input label="Password" v-model="credentials.password" outlined />
      <message v-if="!isLoading && result && result.error" type="negative" class="q-mt-md">
        {{ result.error }}
      </message>
      <div class="text-center">
        <async-btn
          :task="task"
          label="Login"
          type="submit"
          color="primary"
          class="full-width"
          rounded
        />
      </div>
    </form>
    <div v-if="result">
      <captcha
        :session-id="sessionId"
        :result="result"
        @result="result = $event"
        @error="$emit('error')"
      />
      <multi-factor-auth
        :session-id="sessionId"
        :result="result"
        @result="result = $event"
        @error="$emit('error')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { HasTaskMixin } from '@/mixins';
import PasswordInput from '@/components/form/PasswordInput.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import Message from '@/components/message/Message.vue';
import {
  login,
  LoginResult,
  wasSuccess,
  Captcha as CaptchaType,
  MFA,
  Credentials,
} from '.';
import Captcha from './Captcha.vue';
import MultiFactorAuth from './MultiFactorAuth.vue';
import PlatformIcon from '../platform/PlatformIcon.vue';

interface Data {
  credentials: Credentials,
  task: Promise<LoginResult>|null,
  result: LoginResult|null,
}

export default defineComponent({
  emits: ['error', 'success'],
  mixins: [HasTaskMixin],
  components: {
    Message,
    AsyncBtn,
    PasswordInput,
    Captcha,
    MultiFactorAuth,
    PlatformIcon,
  },
  props: {
    sessionId: {
      type: Number,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      credentials: {
        id: '',
        password: '',
      },
      task: null,
      result: null,
    };
  },
  computed: {
    captcha(): CaptchaType|null {
      return this.result ? this.result.captcha : null;
    },
    mfa(): MFA|null {
      return this.result ? this.result.mfa : null;
    },
  },
  watch: {
    result(result): void {
      if (result && wasSuccess(result)) {
        this.$emit('success');
      }
    },
  },
  methods: {
    login() {
      this.task = login(this.sessionId, this.credentials);
      this.task.then((result) => {
        this.result = result;
      });
      this.task.catch(() => {
        this.$emit('error');
      });
    },
  },
});
</script>
